import { MenuItem, Select, Box } from '@mui/material';
import typography from '../../styles/typography.module.css';
import layout from '../../styles/layout.module.css';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const Dropdown = ({ required, type, apiFunction, control, currValue }) => {
    const { t } = useTranslation();
    const currency = useSelector((state) => state.shopifyReducer.ciems[0].currency);
    const { data: options, isLoading, isSuccess, isError } = apiFunction();
    if (isLoading) {
        return (
            <Box className={layout.finalizeSectionContainer}>
                <h4 className={typography.finalizeTitle} style={{ textAlign: 'initial' }}>
                    {type}
                    {required && <span style={{ color: 'red' }}> *</span>}
                </h4>
                <Select
                    style={{ width: '100%', height: '40px' }}
                    labelId={`${type}-dropdown-option-label`}
                    id={`${type}-dropdown-option-label`}
                    value={currValue}
                    label={type}>
                    <MenuItem disabled value="">
                        <em>{t('finalize.select_one')}</em>
                    </MenuItem>
                </Select>
            </Box>
        );
    }
    if (isSuccess) {
        let onValueUpdate = (value) => {
            control(value);
            const curr = options.find((option) => option.SK === value.target.value);
            control({
                SK: curr.SK,
                displayName: curr.displayName,
                price: curr.price ? curr.price : 0
            });
        };

        let activeOptions = options.filter((option) => option.isActive === true);
        let dropdownOptions = activeOptions.map((option) => {
            const price = option.price;
            let textToDisplay =
                t(`finalize.${option.SK}`) !== `finalize.${option.SK}`
                    ? t(`finalize.${option.SK}`)
                    : option.displayName;
            if (price) {
                if (price.localeCompare('0.00') !== 0) {
                    textToDisplay = `${currency}${option.price} - ${textToDisplay}`;
                }
            }

            return (
                <MenuItem value={option.SK} name={t(`finalize.${option.SK}`)} key={option.id}>
                    {textToDisplay}
                </MenuItem>
            );
        });

        return (
            <Box className={layout.finalizeSectionContainer}>
                <h4 className={typography.finalizeTitle} style={{ textAlign: 'initial' }}>
                    {type}
                    {required && <span style={{ color: 'red' }}> *</span>}
                </h4>
                <Select
                    style={{ width: '100%', height: '40px' }}
                    labelId={`${type}-dropdown-option-label`}
                    id={`${type}-dropdown-option-label`}
                    value={currValue}
                    label={type}
                    displayEmpty
                    onChange={(e) => onValueUpdate(e)}>
                    <MenuItem disabled value="">
                        <em>{t('finalize.select_one')}</em>
                    </MenuItem>
                    {dropdownOptions}
                </Select>
            </Box>
        );
    }
    if (isError) {
        return <p>Error</p>;
    }
};

export default Dropdown;
